import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import PasswordHide from "../../assets/images/password-hide.svg";
import PasswordShow from "../../assets/images/password-show.svg";
import {
  Form,
  FormElement,
  FormValidator,
  CustomTextControl,
  BaseReactComponent,
  SelectControl,
} from "../../utils/form";
import { Row, Col, Image } from "react-bootstrap";
import ComponentHeader from "../common/ComponentHeader";
import { registerUserApi, updateUserApi } from "./Api";
import { getAllRolesApi } from "../roles/Api";
import { getAllAmcApi } from "../MasterCategory/Api";
import {
  getAdminUser,
  isPartnerAllowed,
  s3UrlToFile,
  userAmcUuids,
} from "../../utils/ReusableFunctions";
import {
  CREATOR_ID,
  MODULE_ID_MAP,
  SUPERADMIN,
  SUPER_ADMIN,
  isModuleExist,
} from "../../utils/Constant";
import { getAllContentCreatorApi } from "../content/Api";
import { getAllSsoPartnersApi } from "../sso/Api";
import { ImageUploader } from "../common";
import { toast } from "react-toastify";
import { postLoginInstance } from "../../utils";
import { withRouter } from "../../utils/hoc/withRouter";
class AddUser extends BaseReactComponent {
  constructor(props) {
    super(props);
    const editData = props.location?.state?.editData || {};
    const AccessData = isModuleExist(MODULE_ID_MAP.CalculatorCalculator);
    
    let partners = this.loadDefaultPartners(AccessData);
    if (editData?.partners?.list) {
      partners = editData?.partners;
    }
    
    this.state = {
      AccessData,
      editData,
      partners,
      toolName: editData?.toolName || "",
      thumbnailPath: editData?.thumbnailPath || "",
      isAddContent: true,
      resLoading: false,
    };
  }

  componentDidMount() {
    this.props.getAllAmcApi(this);
    getAllContentCreatorApi(this);
    getAllSsoPartnersApi(this);
  }

  componentDidUpdate(prevProps, prevState) {}

  handlePageSize = (pageSize) => {};

  handleSave = () => {
    ReactDOM.findDOMNode(this.form).dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  };
  onValidSubmit = async () => {
    this.setState({ resLoading: true });
    const { toolName, thumbnailPath, partners } = this.state;
    const { editData } = this.state;
    if (!editData?.uuid) {
      this.setState({ resLoading: false });
      toast.error("Add Calculator not allowed");
      return;
    }
    
    console.log(await s3UrlToFile(thumbnailPath || ""));

    let thumbnailPathFile =
      (thumbnailPath instanceof File || thumbnailPath instanceof Blob)
        ? thumbnailPath
        : await s3UrlToFile(thumbnailPath || "") || null;

    const payload = {
      data: {
        toolName,
        partners,
      },
    };
    if(thumbnailPathFile){
      payload.data.thumbnailPath = thumbnailPathFile.name;
    }
    if(!isPartnerAllowed(this.state.AccessData?.id)){
      delete payload.data.partners;
    }

    const formData = new FormData();
    formData.append("key", JSON.stringify(payload));
    if (thumbnailPathFile) formData.append("file", thumbnailPathFile);
    try{
        const res = await postLoginInstance.put(`tools/${editData?.uuid}`, formData);
        this.setState({ resLoading: false });
        toast.success(res?.data?.data?.message || "Calculator updated successfully");
        this.props.history("/calculator");
    }
    catch(error){
        this.setState({ resLoading: false });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };
  render() {
    const { amcOption, resLoading } = this.state;
    return (
      <section className="add-section">
        <ComponentHeader
          title={this.state.editData?.uuid ? "Edit Calculator" : "Add Caluculator"}
          primaryBtn="Save"
          breadcrumb={[["Calculators", "/calculator"], [this.state.editData?.uuid ? "Edit Calculator" : "Add Calculator", ""]]}
          handlePrimaryBtn={() => this.handleSave()}
          isBackArrow={true}
          resLoading={resLoading}
          isReturn="/calculator"
        />
        <Form ref={(el) => (this.form = el)} onValidSubmit={this.onValidSubmit}>
          <Row>
            {isPartnerAllowed(this.state.AccessData?.id) && <Col md={4}>
              <FormElement
                valueLink={this.linkState(this, "partners.list")}
                label="Publish To Partner(s)"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Publish To cannot be empty",
                  },
                ]}
                control={{
                  type: SelectControl,
                  settings: {
                    options: this.state?.ssoPartnersOptions || [],
                    placeholder: "Select Partner(s)",
                    multiple: true,
                    searchable: true,
                    selectAll: true,
                    onChangeCallback: (onBlur) => {},
                  },
                }}
              />
            </Col>}
            <Col md={4}>
              <FormElement
                valueLink={this.linkState(this, "toolName")}
                label="Tool Name"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Tool Name cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    placeholder: "Enter Tool Name",
                  },
                }}
              />
            </Col>
            <Col md={4}>
              <ImageUploader
                required={true}
                id="Thumbnail"
                label="Upload Thumbnail"
                name={
                  this.state?.thumbnailPath instanceof File ||
                  this.state.thumbnailPath?.logo instanceof Blob
                    ? URL.createObjectURL(this.state?.thumbnailPath)
                    : this.state?.thumbnailPath || ""
                }
                onChange={(e) =>
                  this.setState({
                    thumbnailPath: e.target.files?.[0],
                  })
                }
                onDelete={() => this.setState({ thumbnailPath: "" })}
                showLabel={false}
              />
            </Col>
          </Row>
        </Form>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  getAllAmcApi,
};
AddUser.propTypes = {
  // getPosts: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddUser));
